import axios from 'axios';

export default axios.create({
    baseURL: `https://tsg-iitkgp.herokuapp.com`,
});